'use strict';

angular.module('bringgApp').factory('TenderNotifyService', function ($rootScope, BringgSDK, MerchantConfigurations) {
	/**
	 *
	 * @type {import('@bringg/dashboard-sdk').BringgDashboardSDK.v2.taskManagedAttributes}
	 */
	let _taskManagedAttributesSdk;

	BringgSDK.getInstancePromise().then(function (bringg) {
		_taskManagedAttributesSdk = bringg.v2.taskManagedAttributes;
	});

	var TenderNotifyService = {};

	TenderNotifyService.isEnabledForMerchant = function () {
		return !!MerchantConfigurations.enable_tender_notify;
	};

	TenderNotifyService.loadForTasks = function (ids) {
		if (!TenderNotifyService.isEnabledForMerchant()) {
			return Promise.resolve([]);
		}

		if (!ids.length) {
			return Promise.resolve([]);
		}

		return _taskManagedAttributesSdk
			.loadByIds(ids)
			.then(managedAttributes => managedAttributes.map(attributes => attributes?.TenderNotifyStatus))
			.catch(error => {
				console.error('Failed to load tender notify status for tasks', error);
				return [];
			});
	};

	TenderNotifyService.getForTask = function (taskId) {
		const managedAttributes = _taskManagedAttributesSdk.get(taskId);
		if (!managedAttributes) {
			return;
		}

		return managedAttributes.TenderNotifyStatus;
	};

	return TenderNotifyService;
});
